export const manifest = {
  screens: {
    scr_97aw3v: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_jc0sdn: { name: "Product", route: "/product", position: {"x":1560,"y":220} },
    scr_93w23z: { name: "Why not HubSpot workflows?", route: "/why-not-hubspot-workflows", position: {"x":160,"y":2200} },
    scr_6u363f: { name: "Use Cases", route: "/use-cases", position: {"x":2960,"y":220} },
    scr_so3muo: { name: "Book a Demo", route: "/book-a-demo", position: {"x":160,"y":4180} },
  },
  sections: {
    sec_2ybq2j: { name: "Product Information", x: 0, y: 0, width: 4320, height: 1180 },
    sec_24ouj4: { name: "Differentiation", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_53fl35: { name: "Conversion", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_2ybq2j", children: [
      { kind: "screen", id: "scr_97aw3v" },
      { kind: "screen", id: "scr_jc0sdn" },
      { kind: "screen", id: "scr_6u363f" },
    ] },
    { kind: "section", id: "sec_24ouj4", children: [
      { kind: "screen", id: "scr_93w23z" },
    ] },
    { kind: "section", id: "sec_53fl35", children: [
      { kind: "screen", id: "scr_so3muo" },
    ] },
  ],
}
